import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const CurrencyFormatter = (props) => (
  <div className="numeral" style={{ width: 'max-content' }}>
    <NumberFormat
      displayType="text"
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={0}
      fixedDecimalScale={false}
      {...props}
    />
  </div>
);

CurrencyFormatter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  decimalScale: PropTypes.number,
};

CurrencyFormatter.defaultProps = {
  value: null,
  decimalScale: 2,
};

export default CurrencyFormatter;
